export default {
    actions: {
        loadProjects(state, params) {
            return this.dispatch('sendRequest', { path: '/plan/project', params, method: 'get' });
        },
        loadProject(state, {id}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id, data: {}, method: 'get', formErrors: {} });
        },
        createProject(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/plan/project', data, method: 'post', formErrors });
        },
        editProject(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id, data, method: 'post', formErrors });
        },
        changeProjectSequence(state, {id, data}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/sequence', data, method: 'post' });
        },

        loadTasks(state, {id, params}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task', params, method: 'get', formErrors: {} });
        },
        loadTask(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId, data: {}, method: 'get', formErrors: {} });
        },
        createTask(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task', data, method: 'post', formErrors });
        },
        editTask(state, {data, formErrors, id, subId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId, data, method: 'post', formErrors });
        },
        changeTaskStatusNew(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/not-done', data: {}, method: 'post', formErrors: {} });
        },
        changeTaskStatusDone(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/done', data: {}, method: 'post', formErrors: {} });
        },
        changeTaskSequence(state, {id, subId, data}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/sequence', data, method: 'post', formErrors: {} });
        },
        loadTimes(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/time', method: 'get', formErrors: {} });
        },
        createTime(state, {id, subId, data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/time', data, method: 'post', formErrors });
        },
        editTime(state, {id, subId, subSubId, data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/time/'+subSubId, data, method: 'post', formErrors });
        },
        deleteTime(state, {id, subId, subSubId}) {
            return this.dispatch('sendRequest', { path: '/plan/project/'+id+'/task/'+subId+'/time/'+subSubId, data: {}, method: 'delete', formErrors: {} });
        },

        loadProjectReport(state, {id, params}) {
            return this.dispatch('sendRequest', {path: '/plan/project/'+id+'/report', params});
        },

        loadTargets() {
            return this.dispatch('sendRequest', { path: '/plan/target'});
        },
        loadTarget(_, {id}) {
            return this.dispatch('sendRequest', { path: '/plan/target/'+id});
        },
        createTarget(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/plan/target', data, method: 'post', formErrors });
        },
        editTarget(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/plan/target/'+id, data, method: 'post', formErrors });
        },
        targetToArchive(state, {id}) {
            return this.dispatch('sendRequest', { path: '/plan/target/'+id+'/to-archive', method: 'post' });
        },
        countDayTarget(state, {id}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/day'});
        },
        loadImmediateTargets() {
            return this.dispatch('sendRequest', { path: '/plan/target-immediate' });
        },

        loadTargetDairies(state, {id}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/posts'});
        },
        createTargetDairy(state, {id, data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/posts', data, method: 'post', formErrors});
        },
        updateTargetDairy(state, {id, subId, data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/posts/'+subId, data, method: 'post', formErrors});
        },

        loadTargetDairyComments(state, {id, subId}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/post/'+subId+'/comment'});
        },
        createTargetDairyComments(state, {id, subId, formError, data}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/post/'+subId+'/comment', data, method: 'post', formError});
        },
        updateTargetDairyComments(state, {id, subId, subSubId, formErrors, data}) {
            return this.dispatch('sendRequest', {path: '/plan/target/'+id+'/post/'+subId+'/comment/'+subSubId, data, method: 'post', formErrors});
        },

        loadRemindersTasks(state, {params}) {
            return this.dispatch('sendRequest', { path: '/plan/reminder', params });
        }
    }
}